<div [ngClass]="'restart-container'">
   <h1>Restarting. Please wait...</h1>
   <app-wait-spinner></app-wait-spinner>
</div>
